import script from "./PVApprovalPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PVApprovalPage.vue?vue&type=script&setup=true&lang=js"

import "./PVApprovalPage.vue?vue&type=style&index=0&id=22641879&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22641879"]])

export default __exports__